var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.5H22C22.276 11.5 22.5 11.276 22.5 11C22.5 10.724 22.276 10.5 22 10.5H20C19.724 10.5 19.5 10.724 19.5 11C19.5 11.276 19.724 11.5 20 11.5Z",
    fill: "#FF8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2234 7.44693L22.2234 6.44693C22.4704 6.32393 22.5704 6.02293 22.4469 5.77643C22.3239 5.52943 22.0229 5.42942 21.7764 5.55292L19.7764 6.55292C19.5294 6.67592 19.4294 6.97692 19.5529 7.22342C19.6759 7.47042 19.9769 7.57043 20.2234 7.44693Z",
    fill: "#FF8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7764 15.4469L21.7764 16.4469C22.0229 16.5704 22.3239 16.4704 22.4469 16.2234C22.5704 15.9769 22.4704 15.6759 22.2234 15.5529L20.2234 14.5529C19.9769 14.4294 19.6759 14.5294 19.5529 14.7764C19.4294 15.0229 19.5294 15.3239 19.7764 15.4469Z",
    fill: "#FF8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56561 15.5L7.34111 20.9295C7.36161 21.073 7.31861 21.218 7.22361 21.3275C7.12861 21.437 6.99111 21.5 6.84611 21.5H5.75361C5.53011 21.5 5.33411 21.352 5.27261 21.1375L3.66211 15.5H6.56561Z",
    fill: "#FF8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.5V7.5H9C13.194 7.5 16.181 3.986 17.109 2.718C17.1105 2.7155 17.1125 2.7135 17.114 2.7115C17.2075 2.579 17.3595 2.5 17.522 2.5H18C18.276 2.5 18.5 2.724 18.5 3V19C18.5 19.276 18.276 19.5 18 19.5L17.5215 19.4985C17.36 19.4985 17.208 19.42 17.115 19.288C17.113 19.2855 17.1115 19.2835 17.11 19.281C16.1805 18.014 13.194 14.5 9 14.5H7.5Z",
    fill: "#FF8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7.5V14.5H3C2.602 14.5 2.2205 14.342 1.9395 14.0605C1.658 13.7795 1.5 13.398 1.5 13V9C1.5 8.602 1.658 8.2205 1.9395 7.9395C2.2205 7.658 2.602 7.5 3 7.5H6.5Z",
    fill: "#FF8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.098a16893d6171179f8f23afe7b8ccb5.svg";
export { ForwardRef as ReactComponent };